import { IngredientForm } from "./IngredientForm";
import { useParams } from "react-router";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";
import { IngredientCreationV2 } from "./v2/IngredientCreationV2";

export const CreateIngredientPage = () => {
    const { startingPageId } = useParams();
    const isProductUxV2 = useIsProductUxV2();

    if (isProductUxV2) {
        return <IngredientCreationV2 />;
    }

    return <IngredientForm startingPageId={startingPageId ?? "0"} />;
};
